import { MessageCircle } from "lucide-react";
import { useConfig } from "@/hooks/useConfig";

export default function WhatsAppFab() {
  const cfg = useConfig();
  const url = cfg.whatsapp_url;
  if (!url) return null;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Falar no WhatsApp"
      className="hidden md:flex fixed right-6 bottom-6 z-40 items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-2xl hover:scale-110 transition-transform"
    >
      <MessageCircle className="w-6 h-6" />
    </a>
  );
}
